export const FRONTEND = 'frontend';
export const RESOURCE_TYPE = {
    AWS_ALB_TG: 'awsalbtg',
    AWS_NLB_TG: 'awsnlbtg',
};

export const TRAFFIC_TYPE = {
    ALB: 'alb',
    EKS: 'eks',
};

export const DEPARTMENT = {
    AISP: 'AISP',
};

export const SERVICE_NOW_URL =
    'https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_guide_view.do%3Fv%3D1%26sysparm_initial%3Dtrue%26sysparm_guide%3D3c4600ca871449104f31cbbd0ebb35ce%26sysparm_link_parent%3D5688c0290f511700fa1b1b1e51050eab%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_default%26sysparm_view%3Dcatalog_default';

export const INVALID_SUPPORT_GROUP_ERROR_MSG = `During our validation process, we found that the CI support group field for your application service is empty. This field is required for the certificate creation workflow. Please update this information through the <a href="${SERVICE_NOW_URL}" target="_blank" rel="noreferrer" style="color:#0047BA;font-weight:bold;text-decoration:underline">ServiceNow catalog</a>, then resubmit your order once the update is complete`;
